export const QR_FILENAME_DATE_KEYS = ['dd-mm-yyyy', 'yyyy-mm-dd', 'hh-mm'] as const;

export function qrFilenameKeyLabel(key: string): string {
  return key.slice(key.lastIndexOf('.') + 1);
}

export function qrFilenameKeyParent(key: string): string {
  return key.includes('.') ? key.slice(0, key.lastIndexOf('.')) : '';
}

export function qrFilenameExtension(format: string): string {
  return format === 'cmyk-pdf' ? 'pdf' : format === 'cmyk-jpeg' || format === 'jpeg' ? 'jpg' : 'png';
}

interface SchemaField {
  key?: string;
  type?: string;
  properties?: SchemaField[];
}

export function qrFilenameSchemaKeys(schema: SchemaField | undefined): string[] {
  const keys = new Set<string>();
  const visit = (fields: SchemaField[] | undefined, parent = ''): void => {
    for (const field of fields || []) {
      if (!field.key) continue;
      const path = parent ? `${parent}.${field.key}` : field.key;
      if (field.type !== 'object' && field.type !== 'array') keys.add(path);
      if (field.type === 'object') visit(field.properties, path);
      // Array indices are not stable filename keys, so suggest only scalar paths.
    }
  };
  visit(schema?.properties);
  return Array.from(keys).sort((left, right) => left.localeCompare(right));
}

export function insertQrFilenamePlaceholder(template: string, key: string, input: HTMLInputElement): string {
  const placeholder = `{{${key}}}`;
  const start = input.selectionStart ?? template.length;
  const end = input.selectionEnd ?? start;
  const before = template.slice(0, start);
  const after = template.slice(end);
  const inserted = `${before.endsWith('}}') ? '_' : ''}${placeholder}${after.startsWith('{{') ? '_' : ''}`;
  const updated = before + inserted + after;
  queueMicrotask(() => {
    input.focus();
    input.setSelectionRange(start + inserted.length, start + inserted.length);
  });
  return updated;
}

export function qrFilenameTemplateError(template: string, language: 'de' | 'en' = 'en'): string | undefined {
  if (!template.trim()) return undefined;
  const withoutPlaceholders = template.replace(/\{\{[a-zA-Z0-9_.-]+\}\}/g, '');
  if (/[{}]/.test(withoutPlaceholders)) {
    return language === 'de'
      ? 'Ungültiger Platzhalter. Verwende zum Beispiel {{tridyId}} oder {{serialNumber}}.'
      : 'Invalid placeholder. Use {{tridyId}} or {{serialNumber}}, for example.';
  }
  return undefined;
}
